import NotificationCard from './notification-card';
import { electivesNotificationProps } from './notification-card-props';

type ElectivesNotificationCardProps = {
  showLSAPlaceHolders?: boolean; 
};

export default function ElectivesNotificationCard({showLSAPlaceHolders = false}: ElectivesNotificationCardProps) {
  const notificationProps = electivesNotificationProps(showLSAPlaceHolders);
  return (
    <NotificationCard
      content={notificationProps.content}
      buttons={notificationProps.buttons}
      media={notificationProps.media}
      title={notificationProps.title}
    />
  );
}
